export function getButtonListWidth() {
  return document
    .getElementById('toolbar-button-list')
    .getBoundingClientRect()
    .width;
}

export function getListContainer() {
  return document.getElementById('list-container');
}

export function getListContainerWidth() {
  return getListContainer()
    .getBoundingClientRect()
    .width;
}

export function getToolbar() {
  return document.getElementById('toolbar');
}

export function getSideBarWidth() {
  return document.querySelector('.sidebar').getBoundingClientRect()
    .width;
}
